/* /cards-pricing — the MTG card finder, in the browser.
 * The search box takes a name or any Scryfall syntax; colors / type / format / rarity / sort / every
 * printing and the "more filters" sheet add terms to it. Results come straight from Scryfall (175 a
 * page, "show more" appends), as card images or a list. A card opens a sheet with every price,
 * legalities, the other face, a buy link and "Add to collection" (users/{uid}/savedCards, merged by
 * name like the dashboard). All state lives in the URL, so every search can be shared.
 */
import "../lib/site.js";
import "../lib/cards.js";
import "../lib/cardsheet.js";
import "../lib/fb-lazy.js";

(function () {
  "use strict";

  var KD = window.KD, D = KD.data, esc = KD.esc;
  var form = KD.$("[data-csearch]");
  if (!form) return;
  var qEl = KD.$("[data-q]", form), colorsBox = KD.$("[data-colors]"), results = KD.$("[data-results]"), grid = KD.$("[data-grid]");
  var pager = KD.$("[data-pager]"), countEl = KD.$("[data-count]"), warnEl = KD.$("[data-warn]"), none = KD.$("[data-none]"), landing = KD.$("[data-landing]");
  var advBtn = KD.$("[data-advanced]"), advN = KD.$("[data-adv-n]");
  var API = "https://api.scryfall.com/cards/search?";
  var SORT = { popular: ["edhrec", "asc"], name: ["name", "asc"], price: ["usd", "desc"], cheap: ["usd", "asc"], mv: ["cmc", "asc"], new: ["released", "desc"] };
  var ADV = [["o", "Rules text", "e.g. draw a card"], ["e", "Set code", "e.g. fdn"], ["mv", "Mana value", ""], ["pow", "Power", ""], ["tou", "Toughness", ""], ["id", "Fits a commander of these colors", ""]];
  var OPS = /^(=|>=|<=|>|<)\d{1,2}$/;
  var LEGAL = [["standard", "Standard"], ["pioneer", "Pioneer"], ["modern", "Modern"], ["legacy", "Legacy"], ["vintage", "Vintage"], ["commander", "Commander"], ["pauper", "Pauper"], ["historic", "Historic"], ["timeless", "Timeless"], ["brawl", "Brawl"]];
  var RAR = { common: "Common", uncommon: "Uncommon", rare: "Rare", mythic: "Mythic", special: "Special", bonus: "Bonus" };

  var st = blank();
  var list = [], next = "", total = 0, token = 0, view = "grid";
  try { view = localStorage.getItem("kd_cards_view") === "list" ? "list" : "grid"; } catch (e) { /* ignore */ }

  // a button's working state (the label swaps, clicks are ignored until it's done)
  function hold(btn, label) {
    if (!btn) return;
    btn._label = btn.innerHTML;
    btn.classList.add("is-busy");
    btn.setAttribute("aria-busy", "true");
    btn.innerHTML = '<span class="spin" aria-hidden="true"></span><span>' + esc(label) + "</span>";
  }
  function release(btn) {
    if (!btn || btn._label == null) return;
    btn.classList.remove("is-busy");
    btn.removeAttribute("aria-busy");
    btn.innerHTML = btn._label;
    btn._label = null;
  }

  function blank() { return { q: "", c: "", t: "", f: "", r: "", sort: "popular", prints: false, o: "", e: "", mv: "", pow: "", tou: "", id: "" }; }
  function colorsOf(s) { return "WUBRGC".split("").filter(function (c) { return String(s || "").toUpperCase().indexOf(c) !== -1; }).join(""); }

  // ---------------------------------------------------------------- state <-> URL <-> Scryfall
  function fromUrl() {
    var p = new URLSearchParams(location.search), s = blank();
    s.q = (p.get("q") || p.get("card-name") || "").trim().slice(0, 200);
    s.c = colorsOf(p.get("c") || p.get("color"));
    if (s.c.indexOf("C") !== -1) s.c = "C";
    ["t", "f", "r"].forEach(function (k) { s[k] = (p.get(k) || "").toLowerCase().replace(/[^a-z]/g, "").slice(0, 20); });
    s.sort = SORT[p.get("sort")] ? p.get("sort") : "popular";
    s.prints = p.get("prints") === "1";
    s.o = (p.get("o") || "").replace(/"/g, "").slice(0, 80);
    s.e = (p.get("e") || "").toLowerCase().replace(/[^a-z0-9]/g, "").slice(0, 8);
    ["mv", "pow", "tou"].forEach(function (k) { var v = (p.get(k) || "").replace(/\s/g, ""); s[k] = OPS.test(v) ? v : ""; });
    s.id = colorsOf(p.get("id")).replace("C", "");
    return s;
  }
  function toUrl() {
    var p = new URLSearchParams();
    if (st.q) p.set("q", st.q);
    if (st.c) p.set("c", st.c);
    ["t", "f", "r", "o", "e", "mv", "pow", "tou", "id"].forEach(function (k) { if (st[k]) p.set(k, st[k]); });
    if (st.sort !== "popular") p.set("sort", st.sort);
    if (st.prints) p.set("prints", "1");
    var qs = p.toString();
    try { history.replaceState(null, "", "/cards-pricing" + (qs ? "?" + qs : "")); } catch (e) { /* ignore */ }
  }
  function scryQuery() {
    var parts = [];
    if (st.q) parts.push(st.q);
    if (st.c === "C") parts.push("c=c"); else if (st.c) parts.push("c>=" + st.c.toLowerCase());
    if (st.t) parts.push("t:" + st.t);
    if (st.f) parts.push("f:" + st.f);
    if (st.r) parts.push("r:" + st.r);
    if (st.o) parts.push('o:"' + st.o + '"');
    if (st.e) parts.push("e:" + st.e);
    if (st.mv) parts.push("mv" + st.mv);
    if (st.pow) parts.push("pow" + st.pow);
    if (st.tou) parts.push("tou" + st.tou);
    if (st.id) parts.push("id<=" + st.id.toLowerCase());
    return parts.join(" ");
  }
  function advCount() { return ["o", "e", "mv", "pow", "tou", "id"].filter(function (k) { return st[k]; }).length; }

  function paintControls() {
    qEl.value = st.q;
    KD.$$("[data-color]", colorsBox).forEach(function (b) {
      var on = st.c.indexOf(b.getAttribute("data-color")) !== -1;
      b.classList.toggle("is-on", on);
      b.setAttribute("aria-pressed", String(on));
    });
    KD.$$("select[data-f]").forEach(function (s) { s.value = st[s.getAttribute("data-f")] || (s.getAttribute("data-f") === "sort" ? "popular" : ""); });
    var pr = KD.$('input[data-f="prints"]');
    if (pr) pr.checked = st.prints;
    var n = advCount();
    advN.hidden = !n;
    advN.textContent = n || "";
    KD.$$(".view-seg [data-view], [data-results] [data-view]").forEach(function (b) { b.setAttribute("aria-selected", String(b.getAttribute("data-view") === view)); });
  }

  // ---------------------------------------------------------------- results
  function faceImg(c, size) {
    if (c.image_uris) return c.image_uris[size] || c.image_uris.normal || "";
    var f = (c.card_faces || []).filter(function (x) { return x.image_uris; })[0];
    return f ? f.image_uris[size] || f.image_uris.normal : "";
  }
  function priceOf(c) { var p = c.prices || {}; return p.usd || p.usd_foil || p.usd_etched || null; }
  function costOf(c) { return c.mana_cost != null && c.mana_cost !== "" ? c.mana_cost : (c.card_faces && c.card_faces[0] ? c.card_faces[0].mana_cost || "" : ""); }
  function rdot(r) { return '<i class="rdot rdot--' + esc(String(r || "c").charAt(0)) + '"></i>'; }

  function tile(c, k) {
    var img = KD.safeUrl(faceImg(c, "normal")), p = priceOf(c);
    if (view === "list") {
      return '<button type="button" class="crow" data-k="' + k + '"><span class="crow__name">' + esc(c.name) + '</span><span class="crow__cost pips">' + KD.mana(String(costOf(c)).split("//")[0]) + "</span>" +
        '<span class="crow__type">' + esc(c.type_line || "") + '</span><span class="crow__set">' + rdot(c.rarity) + esc(String(c.set || "").toUpperCase()) + "</span>" +
        '<span class="crow__price">' + (p ? "$" + esc(p) : "") + "</span></button>";
    }
    return '<button type="button" class="scard" data-k="' + k + '">' + (img ? '<img src="' + esc(img) + '" alt="' + esc(c.name) + '" width="488" height="680" loading="lazy" decoding="async">' : '<span class="scard__none">' + esc(c.name) + "</span>") +
      '<span class="scard__meta"><span class="scard__name">' + esc(c.name) + '</span><span class="scard__sub"><span>' + rdot(c.rarity) + esc(String(c.set || "").toUpperCase()) +
      '</span><span class="scard__price">' + (p ? "$" + esc(p) : "") + "</span></span></span></button>";
  }
  function paintList(from) {
    var html = list.slice(from).map(function (c, i) { return tile(c, from + i); }).join("");
    grid.className = view === "list" ? "clist" : "sgrid";
    if (!from) grid.innerHTML = view === "list" ? '<div class="crow crow--head" aria-hidden="true"><span>Card</span><span>Cost</span><span>Type</span><span>Set</span><span>Price</span></div>' + html : html;
    else grid.insertAdjacentHTML("beforeend", html);
  }
  function paintPager() {
    var left = total - list.length;
    pager.innerHTML = next && left > 0 ? '<button class="btn btn--ghost" type="button" data-more>Show more cards <small>' + KD.fmt(left) + " more</small></button>" : "";
  }
  function skeleton() {
    grid.className = "sgrid";
    grid.innerHTML = new Array(12).join('<div class="scard scard--skel"><span></span><i></i></div>') + '<div class="scard scard--skel"><span></span><i></i></div>';
  }
  function showLanding(on) {
    landing.hidden = !on;
    results.hidden = on;
    if (on) none.hidden = true;
  }

  function fetchJson(url) {
    return KD.data.scryfall(url, { headers: { Accept: "application/json" } }).then(function (r) { // paced (lib/cards.js)
      return r.json().catch(function () { return {}; }).then(function (j) { return { status: r.status, j: j }; });
    });
  }

  function run(reason) {
    toUrl();
    paintControls();
    var query = scryQuery(), my = ++token;
    if (!query) { list = []; showLanding(true); return; }
    showLanding(false);
    none.hidden = true;
    warnEl.hidden = true;
    countEl.textContent = "Searching…";
    pager.innerHTML = "";
    skeleton();
    // one result per card shows its cheapest printing with a price (Scryfall's default is often an unpriced preview)
    var sq = query + (!st.prints && !/prefer:/i.test(query) ? " prefer:usd-low" : "");
    var url = API + new URLSearchParams({ q: sq, order: SORT[st.sort][0], dir: SORT[st.sort][1], unique: st.prints ? "prints" : "cards" }).toString();
    KD.ga("cards_search", { q: query.slice(0, 100), reason: reason || "" });
    fetchJson(url).then(function (res) {
      if (my !== token) return;
      var j = res.j || {};
      if (res.status === 200 && j.data) {
        list = j.data;
        total = j.total_cards || list.length;
        next = j.has_more ? j.next_page : "";
        countEl.textContent = KD.fmt(total) + (total === 1 ? " card" : " cards") + (st.prints ? " · every printing" : " · cheapest printing shown");
        if (j.warnings && j.warnings.length) { warnEl.textContent = j.warnings.join(" "); warnEl.hidden = false; }
        paintList(0);
        paintPager();
        return;
      }
      list = [];
      results.hidden = true;
      none.hidden = false;
      var bad = res.status === 400 || res.status === 422;
      KD.$("[data-none-title]", none).textContent = bad ? "Scryfall couldn't read that search" : res.status === 404 ? "No cards match that" : "The search didn't go through";
      KD.$("[data-none-text]", none).textContent = bad ? (j.details || "Check the syntax, or search by name.") + (j.warnings && j.warnings.length ? " " + j.warnings.join(" ") : "")
        : res.status === 404 ? "Check the spelling, or loosen a filter." : "Scryfall didn't answer just now. Try again in a moment.";
    }).catch(function () {
      if (my !== token) return;
      results.hidden = true;
      none.hidden = false;
      KD.$("[data-none-title]", none).textContent = "The search didn't go through";
      KD.$("[data-none-text]", none).textContent = "Check your connection and try again.";
    });
  }

  function more() {
    if (!next) return;
    var btn = KD.$("[data-more]", pager), url = next, my = token;
    hold(btn, "Loading…");
    fetchJson(url).then(function (res) {
      if (my !== token) return;
      var j = res.j || {};
      if (res.status !== 200 || !j.data) throw new Error("page " + res.status);
      var from = list.length;
      list = list.concat(j.data);
      next = j.has_more ? j.next_page : "";
      paintList(from);
      paintPager();
    }).catch(function () {
      release(btn);
      KD.toast("Couldn't load more cards. Try again.", "err");
    });
  }

  // ---------------------------------------------------------------- the card sheet
  function signInSheet(what) {
    var sh = KD.sheet({
      title: "Sign in to " + what,
      body: '<p class="hint" style="font-size:15px">A free KrakenTheMeta account keeps a collection of the cards you own, and the AI deck builder can build from it.</p>',
      foot: '<button class="btn btn--ghost" type="button" data-close>Not now</button><a class="btn btn--lure" href="https://krakenthemeta.com/sign-in" data-signin>Sign in or create an account</a>'
    });
    var a = KD.$("[data-signin]", sh.el);
    if (a) a.addEventListener("click", function () { try { localStorage.setItem("kraken_return_to", "/cards-pricing"); } catch (e) { /* ignore */ } });
  }

  async function addToCollection(sc, qty) {
    if (!KD.signedIn) { signInSheet("save cards"); return false; }
    await KD.firebase.load();
    var user = await KD.firebase.user();
    if (!user) { signInSheet("save cards"); return false; }
    var ref = firebase.firestore().collection("users").doc(user.uid).collection("savedCards");
    var ex = await ref.where("name", "==", sc.name).limit(1).get();
    if (!ex.empty) {
      var d = ex.docs[0];
      await d.ref.update({ quantity: (Number((d.data() || {}).quantity) || 1) + qty });
    } else {
      await ref.add(D.cardShape(sc, qty, false));
    }
    KD.ga("cards_add_to_collection", { card: sc.name, qty: qty });
    return true;
  }

  function openCard(sc) {
    var faces = (sc.card_faces || []).filter(function (f) { return f.image_uris; });
    var imgs = faces.length > 1 ? faces.map(function (f) { return f.image_uris.normal; }) : [faceImg(sc, "normal")];
    var texts = sc.card_faces && !sc.oracle_text ? sc.card_faces.map(function (f) { return (f.name ? f.name + "\n" : "") + (f.oracle_text || ""); }).join("\n\n") : sc.oracle_text || "";
    var pt = sc.power != null ? sc.power + " / " + sc.toughness : sc.loyalty != null ? "Loyalty " + sc.loyalty : sc.card_faces && sc.card_faces[0].power != null ? sc.card_faces[0].power + " / " + sc.card_faces[0].toughness : "";
    var p = sc.prices || {};
    var PR = [["usd", "TCGplayer", "$"], ["usd_foil", "Foil", "$"], ["usd_etched", "Etched", "$"], ["eur", "Cardmarket", "€"], ["tix", "MTGO", ""]];
    var prices = PR.filter(function (x) { return p[x[0]]; }).map(function (x) { return "<div><b>" + x[2] + esc(p[x[0]]) + (x[0] === "tix" ? " tix" : "") + "</b><span>" + x[1] + "</span></div>"; }).join("");
    var legal = LEGAL.map(function (x) {
      var v = (sc.legalities || {})[x[0]] || "not_legal";
      return '<span class="clegal__f is-' + esc(v) + '" title="' + esc(x[1] + ": " + v.replace("_", " ")) + '">' + x[1] + "</span>";
    }).join("");
    var front = sc.name.split(" // ")[0];
    var s = KD.sheet({
      title: esc(sc.name), size: "lg",
      body: '<div class="cardx cardx--full"><div class="cardx__media">' + KD.cardx.img(imgs[0], sc.name) +
        (imgs.length > 1 ? '<button class="btn btn--ghost btn--sm" type="button" data-flip>' + KD.icon("refresh") + "<span>Show the other face</span></button>" : "") + "</div>" +
        '<div class="cardx__info"><div class="row"><span class="pips">' + KD.mana(String(costOf(sc)).split("//")[0]) + "</span>" + (pt ? '<span class="badge">' + esc(pt) + "</span>" : "") + "</div>" +
        '<p class="cardx__type">' + esc(sc.type_line || "") + "</p>" +
        (texts ? '<p class="cardx__text">' + esc(texts).replace(/\{[^}]+\}/g, function (m) { return KD.mana(m); }) + "</p>" : "") +
        '<p class="cset">' + rdot(sc.rarity) + '<a href="/sets?set=' + encodeURIComponent(sc.set || "") + '">' + esc(sc.set_name || "") + "</a> · " + esc(String(sc.set || "").toUpperCase()) + " #" + esc(sc.collector_number || "") + " · " + esc(RAR[sc.rarity] || "") + "</p>" +
        (prices ? '<div class="cprices">' + prices + "</div>" : '<p class="hint">No price yet.</p>') +
        '<div class="clegal">' + legal + "</div>" +
        '<div class="cadd"><div class="qtyctl" role="group" aria-label="Copies to add"><button class="iconbtn iconbtn--sm" type="button" data-qd="-1" aria-label="One fewer">' + KD.icon("minus") + "</button><b data-qv>1</b>" +
        '<button class="iconbtn iconbtn--sm" type="button" data-qd="1" aria-label="One more">' + KD.icon("plus") + '</button></div><button class="btn btn--lure btn--sm" type="button" data-add>' + KD.icon("plus") + "<span>Add to collection</span></button></div>" +
        '<div class="cardx__actions">' + KD.cardx.buyBtn(front) +
        '<a class="btn btn--ghost btn--sm" href="/cards-pricing?q=' + encodeURIComponent('!"' + front + '"') + '&prints=1" data-printings>' + KD.icon("layers") + "<span>Every printing</span></a></div></div></div>"
    });
    var qty = 1, face = 0;
    KD.$$("[data-qd]", s.el).forEach(function (b) {
      b.addEventListener("click", function () { qty = Math.max(1, Math.min(99, qty + parseInt(b.getAttribute("data-qd"), 10))); KD.$("[data-qv]", s.el).textContent = qty; });
    });
    var flip = KD.$("[data-flip]", s.el);
    if (flip) flip.addEventListener("click", function () { face = (face + 1) % imgs.length; KD.$(".cardx__img", s.el).src = imgs[face]; });
    var add = KD.$("[data-add]", s.el);
    add.addEventListener("click", function () {
      hold(add, "Adding…");
      addToCollection(sc, qty).then(function (ok) {
        release(add);
        if (ok) { s.close(); KD.toast("Added " + qty + " × " + sc.name + " to your collection.", "ok"); }
      }).catch(function (e) { console.error("add to collection", e); release(add); KD.toast("That didn't save. Try again.", "err"); });
    });
    var pl = KD.$("[data-printings]", s.el);
    if (pl) pl.addEventListener("click", function (e) {
      e.preventDefault();
      s.close();
      st = blank();
      st.q = '!"' + front + '"';
      st.prints = true;
      st.sort = "new";
      run("printings");
      window.scrollTo({ top: 0, behavior: KD.reduce ? "auto" : "smooth" });
    });
    KD.ga("cards_open", { card: sc.name });
    return s;
  }

  function openById(id) {
    fetchJson("https://api.scryfall.com/cards/" + encodeURIComponent(id)).then(function (res) {
      if (res.status === 200 && res.j && res.j.name) openCard(res.j);
      else KD.toast("Couldn't load that card. Try again.", "err");
    }).catch(function () { KD.toast("Couldn't load that card. Try again.", "err"); });
  }

  // ---------------------------------------------------------------- hover preview in the list view
  var fine = window.matchMedia("(hover: hover) and (pointer: fine)"), pop = null, peek = null;
  function unpeek() { peek = null; if (pop) pop.classList.remove("is-on"); }
  grid.addEventListener("mouseover", function (e) {
    if (!fine.matches || view !== "list") return;
    var row = e.target.closest(".crow[data-k]");
    if (!row || row === peek) return;
    var c = list[+row.getAttribute("data-k")], url = c && KD.safeUrl(faceImg(c, "normal"));
    if (!url) return;
    peek = row;
    if (!pop) { pop = document.createElement("div"); pop.className = "cpop"; pop.setAttribute("aria-hidden", "true"); pop.innerHTML = '<img alt="">'; document.body.appendChild(pop); }
    pop.firstChild.src = url;
    var r = row.getBoundingClientRect(), w = 236, h = Math.round(w * 680 / 488);
    var left = e.clientX + 28;
    if (left + w > window.innerWidth - 10) left = e.clientX - w - 28;
    pop.style.left = Math.max(10, left) + "px";
    pop.style.top = Math.max(10, Math.min(window.innerHeight - h - 10, r.top + r.height / 2 - h / 2)) + "px";
    pop.classList.add("is-on");
  });
  grid.addEventListener("mouseleave", unpeek);
  window.addEventListener("scroll", unpeek, { passive: true });

  // ---------------------------------------------------------------- the "more filters" sheet
  function openAdvanced() {
    var opSel = function (k) {
      var v = st[k], m = v.match(/^(=|>=|<=|>|<)(\d+)$/) || ["", "=", ""];
      return '<div class="opfield"><select class="select" data-op="' + k + '" aria-label="' + k + ' comparison">' + ["=", ">=", "<="].map(function (o) { return '<option value="' + o + '"' + (m[1] === o ? " selected" : "") + ">" + (o === "=" ? "exactly" : o === ">=" ? "at least" : "at most") + "</option>"; }).join("") +
        '</select><input class="input" type="number" min="0" max="99" inputmode="numeric" data-num="' + k + '" value="' + esc(m[2]) + '" placeholder="any"></div>';
    };
    var body = ADV.map(function (a) {
      var k = a[0], field;
      if (k === "o" || k === "e") field = '<input class="input" type="text" data-adv="' + k + '" value="' + esc(st[k]) + '" placeholder="' + esc(a[2]) + '" autocomplete="off"' + (k === "e" ? ' maxlength="8"' : ' maxlength="80"') + ">";
      else if (k === "id") field = '<div class="colors" data-adv-id>' + "WUBRG".split("").map(function (c) { return '<button type="button" data-idc="' + c + '" aria-pressed="' + (st.id.indexOf(c) !== -1) + '" class="' + (st.id.indexOf(c) !== -1 ? "is-on" : "") + '"><img src="/assets/img/mana/' + c + '.svg" alt="' + c + '" width="20" height="20"></button>'; }).join("") + "</div>";
      else field = opSel(k);
      return '<label class="field"><span class="label">' + a[1] + "</span>" + field + "</label>";
    }).join("");
    var s = KD.sheet({
      title: "More filters",
      sub: "Added to whatever is in the search box.",
      body: '<div class="stack advform">' + body + "</div>",
      foot: '<button class="btn btn--ghost" type="button" data-adv-clear>Clear these</button><button class="btn btn--lure" type="button" data-adv-go>Search</button>'
    });
    KD.$$("[data-idc]", s.el).forEach(function (b) {
      b.addEventListener("click", function () { var on = !b.classList.contains("is-on"); b.classList.toggle("is-on", on); b.setAttribute("aria-pressed", String(on)); });
    });
    KD.$("[data-adv-clear]", s.el).addEventListener("click", function () {
      ["o", "e", "mv", "pow", "tou", "id"].forEach(function (k) { st[k] = ""; });
      s.close();
      run("advanced-clear");
    });
    KD.$("[data-adv-go]", s.el).addEventListener("click", function () {
      st.o = (KD.$('[data-adv="o"]', s.el).value || "").replace(/"/g, "").trim().slice(0, 80);
      st.e = (KD.$('[data-adv="e"]', s.el).value || "").toLowerCase().replace(/[^a-z0-9]/g, "").slice(0, 8);
      ["mv", "pow", "tou"].forEach(function (k) {
        var n = (KD.$('[data-num="' + k + '"]', s.el).value || "").trim();
        st[k] = /^\d{1,2}$/.test(n) ? KD.$('[data-op="' + k + '"]', s.el).value + n : "";
      });
      st.id = KD.$$("[data-idc].is-on", s.el).map(function (b) { return b.getAttribute("data-idc"); }).join("");
      s.close();
      run("advanced");
    });
  }

  // ---------------------------------------------------------------- wiring
  form.addEventListener("submit", function (e) {
    e.preventDefault();
    st.q = qEl.value.trim().slice(0, 200);
    run("search");
    if (KD.mobile()) qEl.blur();
  });
  KD.$$("[data-example]").forEach(function (a) {
    a.addEventListener("click", function (e) {
      e.preventDefault();
      st = blank();
      st.q = a.getAttribute("data-example");
      run("example");
      var top = KD.$("[data-ctools]");
      if (top && KD.mobile()) window.scrollTo({ top: top.getBoundingClientRect().top + window.pageYOffset - 80, behavior: KD.reduce ? "auto" : "smooth" });
    });
  });
  colorsBox.addEventListener("click", function (e) {
    var b = e.target.closest("[data-color]");
    if (!b) return;
    var c = b.getAttribute("data-color");
    if (c === "C") st.c = st.c === "C" ? "" : "C";
    else {
      var cur = st.c === "C" ? "" : st.c;
      st.c = cur.indexOf(c) !== -1 ? cur.replace(c, "") : colorsOf(cur + c);
    }
    run("colors");
  });
  KD.$$("select[data-f]").forEach(function (s) {
    s.addEventListener("change", function () { st[s.getAttribute("data-f")] = s.value; run(s.getAttribute("data-f")); });
  });
  var printsBox = KD.$('input[data-f="prints"]');
  if (printsBox) printsBox.addEventListener("change", function () { st.prints = printsBox.checked; run("prints"); });
  advBtn.addEventListener("click", openAdvanced);
  pager.addEventListener("click", function (e) { if (e.target.closest("[data-more]")) more(); });
  KD.$("[data-clear]").addEventListener("click", function () { st = blank(); run("clear"); qEl.focus(); });
  KD.$$("[data-results] [data-view]").forEach(function (b) {
    b.addEventListener("click", function () {
      view = b.getAttribute("data-view");
      try { localStorage.setItem("kd_cards_view", view); } catch (e) { /* ignore */ }
      paintControls();
      if (list.length) { paintList(0); paintPager(); }
    });
  });
  grid.addEventListener("click", function (e) {
    var t = e.target.closest("[data-k]");
    if (t && list[+t.getAttribute("data-k")]) { unpeek(); openCard(list[+t.getAttribute("data-k")]); }
  });
  if (landing) landing.addEventListener("click", function (e) {
    var t = e.target.closest("[data-id]");
    if (t) openById(t.getAttribute("data-id"));
  });
  document.addEventListener("keydown", function (e) {
    if (e.key === "/" && !/^(INPUT|TEXTAREA|SELECT)$/.test((document.activeElement || {}).tagName || "") && !KD.$(".sheet.is-open")) { e.preventDefault(); qEl.focus(); qEl.select(); }
  });

  st = fromUrl();
  paintControls();
  if (scryQuery()) run("url"); else showLanding(true);
})();
